import type { Resource } from '../../';
export const product_details_checkoutNow: Resource = {"default":"Checkout Now"};
